import { render, staticRenderFns } from "./user-pay-permeability.vue?vue&type=template&id=67878d1d&scoped=true&"
import script from "./user-pay-permeability.vue?vue&type=script&lang=js&"
export * from "./user-pay-permeability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67878d1d",
  null
  
)

export default component.exports